import { NotificationType } from '@/resources/enums/orders'
import { forwardRef, useRef, Ref, useImperativeHandle } from 'react'

import alertSound from '@/assets/sounds/door-bell.mp3'
import turboSound from '@/assets/sounds/turbo-orders-notification.mp3'
import scheduledSound from '@/assets/sounds/scheduled-orders-notification.mp3'

export type OrderRef = {
  playAudio: (type: NotificationType) => void
}

const OrderBell = (_: unknown, ref: Ref<OrderRef>) => {
  const defaultAudioRef = useRef<HTMLAudioElement>(null)
  const turboAudioRef = useRef<HTMLAudioElement>(null)
  const scheduledAudioRef = useRef<HTMLAudioElement>(null)

  const playAudio = async (type: NotificationType) => {
    switch (type) {
      case NotificationType.TURBO:
        await turboAudioRef.current?.play()
        break
      case NotificationType.SCHEDULED:
        await scheduledAudioRef.current?.play()
        break
      case NotificationType.DEFAULT:
        await defaultAudioRef.current?.play()
    }
  }

  useImperativeHandle(ref, () => ({ playAudio }))

  return (
    <>
      <audio
        data-testid="order-bell-audio"
        ref={defaultAudioRef}
        src={alertSound}
      >
        <track kind="captions" />
      </audio>

      <audio
        data-testid="turbo-order-bell-audio"
        ref={turboAudioRef}
        src={turboSound}
      >
        <track kind="captions" />
      </audio>

      <audio
        data-testid="scheduled-order-bell-audio"
        ref={scheduledAudioRef}
        src={scheduledSound}
      >
        <track kind="captions" />
      </audio>
    </>
  )
}

export default forwardRef(OrderBell)
